export default __webpack_public_path__ + "02af8ad7506957bfb6493f19bc26ad73.svg";